<template>
  <div>
    <vs-popup fullscreen :title="$t('Products')" :active.sync="showModal">
      <form>
        <div class="vx-row mb-6">
          <div class="vx-col lg:w-2/3 w-full">
            <label class="vs-select--label">{{ $t("Product") }}</label>
            <treeselect
              v-model="model.stockId"
              name="product"
              :multiple="false"
              :placeholder="$t('Search')"
              :async="true"
              :load-options="loadOptions"
              v-validate="'required'"
              class="search-input"
              ref="product"
              @select="onProductSelected"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <div class="vx-row">
              <div class="vx-col sm:w-1/6 w-full pt-6">
                <vs-button
                  type="filled"
                  size="medium"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="d-inline"
                  @click.prevent="addProduct()"
                ></vs-button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[
          { title: $t('PersianName'), sort: 'PersianName' },
          { title: $t('Price'), sort: 'Price' },
          { title: $t('Action') },
        ]"
      >
        <template slot-scope="{ row }">
          <td style="width: 60%">
            {{ row.persianName }}
          </td>
          <td style="width: 27%">
            <span v-if="row.price">
              {{ Number(row.price).toLocaleString() }} {{ $t("Rials") }}
            </span>
            <span v-else> - </span>
          </td>
          <td style="width: 10%">
            <vs-button
              radius
              color="danger"
              size="small"
              type="gradient"
              icon-pack="feather"
              icon="icon-x"
              @click.prevent="unassignProduct(row.actualProductId)"
              class="d-inline"
            ></vs-button>
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.add-btn {
  margin-top: 1.5rem;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    product: {
      required: "لطفا محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content_Managment_Menus_ProductPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },

  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},
      info: {},
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  methods: {
    ...mapActions({
      assignProductToMenu: "menu/assignProductToMenu",
      fetchSearch: "sale/fetchActualSearch",
      unassignProductFromMenu: "menu/unassignProductFromMenu",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onProductSelected(data) {
      this.info = {
        id: this.model.id,
        productId: data.id,
      };
    },
    addProduct() {
      this.assignProductToMenu(this.info).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "محصول به قرارداد موردنظر افزوده شد!",
          color: "success",
        });
        this.$refs.grid.renderGrid();
      });
      this.$refs.product.clear();
    },
    unassignProduct(productId) {
      var id = this.model.id;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.unassignProductFromMenu({ id, productId }).then(() => {
            this.$emit("finish");
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.$validator.reset();
        this.gridDataSource = {
          type: "app",
          service: "CMS/api/MenuProductsQuery",
        };
        this.gridSearchData = {
          menuId: this.model.id,
        };
      } else this.gridDataSource = { data: [] };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
  },
  components: {
    Treeselect,
    DataGrid,
    "v-select": vSelect,
  },
};
</script>
